module.exports = __webpack_public_path__ + "img/83.4cdcb56f.webp";